export const confirmAllType = [
  {value: 'CONFIRMING', label: '심사 중'},
  {value: 'APPROVED', label: '심사 승인'},
  {value: 'REJECTED', label: '심사 반려'}
]